import Vue from 'vue'
import _ from 'lodash'

function confirm(options) {
    const div = document.createElement('div')
    div.className = 'sets-confirm'
    div.innerHTML = `
            <div class="modal fade" tabindex="-1" role="dialog" v-el:modal>
                <div class="modal-dialog" style="width: 600px">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">{{title}}</h4>
                        </div>
                        <div class="modal-body">
                            {{content}}
                        </div>
                        <div class="modal-footer">
                            <button type="button"
                                    class="btn btn-default"
                                    data-dismiss="modal"
                                    v-text="cancelText||'取消'">
                            </button>
                            <button type="button"
                                    class="btn"
                                    :class="['btn-'+theme]"
                                    @click='onOkClicked'
                                    v-text="okText||'确定'"
                            >
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        `
    document.body.appendChild(div)
    options = _.assign({
        visible: false,
        onOk: () => {},
        onCancel: () => {}
    }, options)
    /* eslint-disable no-new */
    new Vue({
        el: div,
        data: options,
        methods: {
            onOkClicked() {
                $(this.$els.modal).modal('hide')
                this.onOk()
            }
        },
        ready() {
            $(this.$els.modal).modal({
                backdrop: 'static',
                show: true
            }).on('hidden.bs.modal', () => {
                this.$destroy()
                document.body.removeChild(div)
            })
        }
    })
}

/**
 *
 * 确认提示框:
 *
 * options: {
 *  title: '标题',
 *  content: '内容',
 *  cancelable: false,
 *  cancelText: '取消按钮文字',
 *  okText: '确定按钮文字',
 *  // 点击 ok 按钮
 *  onOk() {
 *  },
 *  // 点击 cancel 按钮
 *  onCancel() {
 *  }
 * }
 */
export default {
    info(options) {
        return confirm(_.assign(options, { theme: 'info' }))
    },
    success(options) {
        return confirm(_.assign(options, { theme: 'success' }))
    },
    danger(options) {
        return confirm(_.assign(options, { theme: 'danger' }))
    },
    warning(options) {
        return confirm(_.assign(options, { theme: 'warning' }))
    }
}



// WEBPACK FOOTER //
// ./bootsets/components/confirm/index.js